import { styled } from '@mui/material/styles';
import SettingControl from 'components/SettingControl';

export const StyledSettingControl = styled(SettingControl)({
  justifyContent: 'flex-start',
  '.SettingControl-label-wrapper': {
    flexBasis: '360px',
  },
});
